import React, { useCallback, useEffect, useRef, useState } from "react";
import styles from './index.module.css';
import { useDispatch, useSelector } from "react-redux";
import { editOrder, getAllOrders } from "../../../redux/features/orders/ordersService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck, faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import Pagination from "../../../components/Pagination";
import TableSkeleton from "../../../components/Skeleton";
import NoResultsFound from "../../../components/NoResultsFound";
import { NumericFormat } from "react-number-format";
import { getAllQuickInvoiceList, getAllQuickInvoiceListByStaff } from "../../../redux/features/quickInvoice/quickInvoiceService";
import SearchBar from "../../../components/SearchBar";

const QuickInvoices = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { isInvoiceListLoading, invoiceList, pageCount } = useSelector((state) => state.quickInvoice.allInvoiceListByStaff);

    const [skip, setSkip] = useState(0);
    const limit = 10;
    const [searchQuery, setSearchQuery] = useState('');

    useEffect(() => {
        dispatch(getAllQuickInvoiceListByStaff({
            skip: skip,
            limit,
            invoice_no: searchQuery
        }));
    }, [dispatch, searchQuery, skip]);

    const openNewInvoice = () => navigate('/specialist/quick-invoices/create-quick-invoice');

    const viewDocument = (document) => {
        window.open(document.invoice_document, "_blank");
    }

    const handlePageChange = (pageNumber) => {
        setSkip(pageNumber - 1);
    };

    const editDocument = (document) => navigate(`/specialist/quick-invoices/${document.id}`);

    return (
        <div className={`card-section`}>
            <div className={`search-card`}>
                <div className={`search-card-header`}>
                    <h1 className={`form-title`}>Quick Invoices <FontAwesomeIcon icon={faPlusCircle} onClick={openNewInvoice} style={{ cursor: 'pointer' }} /></h1>
                    <SearchBar onSearch={(query) => setSearchQuery(query)} />
                </div>
                <div className={`search-card-body`}>
                    {isInvoiceListLoading ?
                        <TableSkeleton columns={["Invoice No", "Invoice Date", "Bill to Name", "Country", "Currency", "Staff", "Invoice"]} rowCount={10} height={20} />
                        : invoiceList.length > 0 ?
                            <div className={`table-container`}>
                                <table className={`table`}>
                                    <thead className={`thead`}>
                                        <tr>
                                            <th className={`theadColumnOne`}>Invoice No</th>
                                            <th>Invoice Date</th>
                                            <th>Bill to Name</th>
                                            <th>Country</th>
                                            <th>Currency</th>
                                            <th>Staff</th>
                                            <th>Invoice</th>
                                        </tr>
                                    </thead>
                                    <tbody className={`tbody`}>
                                        {invoiceList?.map((invoice) => (
                                            <tr key={invoice.id}>
                                                <td className={`tdataColumnOne`}>
                                                    {invoice?.invoice_no}
                                                </td>
                                                <td>{invoice?.invoice_date}</td>
                                                <td>{invoice?.bill_to_name}</td>
                                                <td>{invoice?.country}</td>
                                                <td>{invoice?.currency}</td>
                                                <td>{invoice?.staff?.full_name}</td>
                                                <td className={`actionsBtn ${styles.actionCol}`}>
                                                    <button className={`btn-edit-label`} onClick={() => {
                                                        viewDocument(invoice)
                                                    }}>View</button>
                                                    <button className={`btn-edit-label`} onClick={() => {
                                                        editDocument(invoice)
                                                    }}>Edit</button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            :
                            <NoResultsFound />
                    }
                </div>
                <div className={`search-card-footer`}>
                    {pageCount > 0 && (
                        <div className={styles.paginationContainer}>
                            <Pagination
                                currentPage={skip + 1}
                                totalPages={pageCount}
                                onPageChange={handlePageChange}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default QuickInvoices;
